"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animate = animate;
var _get = _interopRequireDefault(require("lodash/get"));
function easeInOutSin(time) {
  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}

/**
 *
 * Simple implementation of HTML animation handler from @material-ui
 * Reference: https://github.com/mui-org/material-ui/blob/next/packages/material-ui/src/internal/animate.js
 *
 */
function animate(element, property, to) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var start = null;
  var _options$ease = options.ease,
    ease = _options$ease === void 0 ? easeInOutSin : _options$ease,
    _options$duration = options.duration,
    duration = _options$duration === void 0 ? 300 : _options$duration;
  var from = (0, _get["default"])(element, property);
  var step = function step(timestamp) {
    if (start === null) start = timestamp;
    var time = Math.min(1, (timestamp - start) / duration);
    element.scrollLeft = ease(time) * (to - from) + from;

    // Timeout
    if (time >= 1) return;
    requestAnimationFrame(step);
  };
  if (from === to) return;
  requestAnimationFrame(step);
}
//# sourceMappingURL=animate.js.map